import {isNilOrEmpty} from 'ramda-adjunct';

export const getPriceWithVat = (price: string, vatRate: number) => {
  const amount = parseFloat(price);

  if (isNilOrEmpty(amount) || isNaN(amount) || !isValidNumberString(price)) {
    return 0;
  }

  return amount * (1 + vatRate / 100);
};

const isValidNumberString = (str: string) => /^-?(\d+\.?\d*|\d*\.\d+)$/.test(str.trim());
